const PbxxRecord = require('../pbxx_record')
const DEFAULT_CAMPAIGN_LOGO = './images/default-campaign-background.png'
const DEFAULT_BRAND_LOGO = './images/logo-default.png'

module.exports = class AllocationDetail extends PbxxRecord {
  static get class_name() {
    return 'AllocationDetail'
  }

  get get_logo_url() {
  	let url
  	if (this.logo_url) {
  	  url = this.logo_url
  	} else if (this.campaign_id) {
      url = DEFAULT_CAMPAIGN_LOGO
    } else {
      url = DEFAULT_BRAND_LOGO
    }
    return url
  }

}
